import React from 'react'
import DatePicker from 'react-datepicker';
import es from "date-fns/locale/es";
import en from "date-fns/locale/en-US";
import pt from "date-fns/locale/pt-BR";
import it from "date-fns/locale/it";
import { getDataUserByKey, getTenantInfoByKey } from '../../helpers/helpers';

export const CustomDateInput = ({ value, onChange, placeholderText = null, name, disabled = false, maxDate = "", minDate = "" }) => {

    const language = getDataUserByKey('language');

    const dateFormat = getDataUserByKey('date_format') || getTenantInfoByKey('date_format');

    const dateSeparator = getDataUserByKey('date_separator') || getTenantInfoByKey('date_separator');

    const languages = {
        es: es,
        mx: es,
        ch: es,
        br: pt,
        en: en,
        it: it,
        pe: es,
        ec: es
    };

    const currentLanguage = languages[language];

    const getDateFormat = () => {
        const formats = {
            "DDMMYYYY": `dd${dateSeparator}MM${dateSeparator}yyyy`,
            "MMDDYYYY": `MM${dateSeparator}dd${dateSeparator}yyyy`,
            "YYYYMMDD": `yyyy${dateSeparator}MM${dateSeparator}dd`,
            "YYYYDDMM": `yyyy${dateSeparator}dd${dateSeparator}MM`,
            "DDYYYYMM": `dd${dateSeparator}yyyy${dateSeparator}MM`,
            "MMYYYYDD": `MM${dateSeparator}yyyy${dateSeparator}dd`,
        }

        const format = formats[dateFormat] ? formats[dateFormat] : formats['YYYYMMDD'];

        return format;
    }

    const placeholder = `${placeholderText ? placeholderText + ' ' : ''}${getDateFormat()}`;

    const newDateToYYYYMMDD = (date) => {
        if (!date) return '';

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    const YYYYMMDDtoNewDate = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-').map(Number);
        return new Date(year, month - 1, day, 0, 0, 0);
    }

    return (
        <div>
            <DatePicker
                selected={YYYYMMDDtoNewDate(value)}
                onChange={(date) => onChange(newDateToYYYYMMDD(date))}
                dateFormat={getDateFormat()}
                name={name}
                locale={currentLanguage}
                placeholderText={placeholder}
                maxDate={YYYYMMDDtoNewDate(maxDate)}
                minDate={YYYYMMDDtoNewDate(minDate)}
                className="form-control"
                disabled={disabled}
            />
        </div>
    )

}
